import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { AgmCoreModule, LAZY_MAPS_API_CONFIG } from "@agm/core";
import { NgbDropdownModule, NgbTabsetModule } from "@ng-bootstrap/ng-bootstrap";

import { CalendarModule } from "../../calendar/calendar.module";
import { GoogleMapsStaticModule } from "../../shared/component/google-maps-static/google-maps-static.module";
import { GoogleMapsConfig } from "../../shared/googleMapsConfig";
import { LoadingModule } from "../../shared/module/loading/loading.module";
import { VenuePipeModule } from "../venue-pipe.module";
import { CarouselComponent } from "./carousel.component";
import { TabsComponent } from "./tabs.component";
import { VenueContentComponent } from "./venue-content.component";

import {
    BadgeSharedModule,
    ButtonSharedModule,
    IconSharedModule,
    ImgServiceDirectiveModule,
    InputSharedModule,
    LoadingSharedModule,
    ModalSharedModule,
    TooltipSharedModule,
} from "pf_styleguide";

import { TransformCamelCaseEsportsModule } from "pf_styleguide/shared";
import { VenueContentModalComponent } from "./venue-content-modal/venue-content-modal.component";
import { ReactiveFormsModule } from "@angular/forms";
import { MandrillService } from "app/partner/mandrill.service";
import { CheckmarkModule } from "app/shared/module/checkmark/checkmark.module";

@NgModule({
    declarations: [
        CarouselComponent, 
        TabsComponent, 
        VenueContentComponent, 
        VenueContentModalComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        CalendarModule,
        VenuePipeModule,
        BadgeSharedModule,
        ButtonSharedModule,
        TooltipSharedModule,
        TransformCamelCaseEsportsModule,
        NgbDropdownModule,
        NgbTabsetModule,
        AgmCoreModule.forRoot(),
        ModalSharedModule,
        GoogleMapsStaticModule,
        LoadingModule,
        IconSharedModule,
        ImgServiceDirectiveModule,
        ReactiveFormsModule,
        InputSharedModule,
        CheckmarkModule,
        LoadingSharedModule
    ],
    providers: [
        {
            provide: LAZY_MAPS_API_CONFIG,
            useClass: GoogleMapsConfig,
        },
        MandrillService
    ],
    exports: [VenueContentComponent],
})
export class VenueContentModule {}
